"use client";

import { ScrollAreaAutosize } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Label,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { builder } from "@/builders";
import dayjs from "dayjs";

export function TimeSpent() {
  const [focusBar, setFocusBar] = useState<number>();

  const { data: performanceMetrics } = useQuery({
    queryKey: builder.data.performance_metrics.$get(),
    queryFn: builder.$use.data.performance_metrics,
    select: ({ data }) =>
      data?.map((item) => ({
        ...item,
        time: dayjs(item.time).format("ddd"),
      })),
  });

  const xDataKey = "time";
  const yDataKey = "points";

  return (
    <ScrollAreaAutosize>
      <BarChart
        maxBarSize={35}
        width={500}
        height={300}
        data={performanceMetrics}
        margin={{
          top: 20,
          right: 30,
          left: 30,
          bottom: 40,
        }}
        onMouseMove={({ isTooltipActive, activeTooltipIndex }) => {
          setFocusBar(isTooltipActive ? activeTooltipIndex : undefined);
        }}
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <defs>
          <pattern
            id="stripes"
            width="4"
            height="4"
            patternUnits="userSpaceOnUse"
            patternTransform="rotate(45)"
          >
            <rect
              width="3"
              height="4"
              transform="translate(0,0)"
              fill="white"
            />
          </pattern>
          <mask id="mask-stripe">
            <rect x="0" y="0" width="100%" height="100%" fill="url(#stripes)" />
          </mask>
        </defs>
        <CartesianGrid vertical={false} strokeWidth={0.5} />
        <XAxis tickLine={false} axisLine={false} dataKey={xDataKey}>
          <Label
            value={xDataKey}
            position="bottom"
            style={{ textAnchor: "middle" }}
            className="prose-xs/medium"
          />
        </XAxis>
        <YAxis tickLine={false} axisLine={false}>
          <Label
            angle={-90}
            value={yDataKey}
            position="left"
            style={{ textAnchor: "middle" }}
            className="prose-xs/medium"
          />
        </YAxis>
        <Tooltip cursor={{ fill: "transparent" }} />

        <Bar dataKey={yDataKey}>
          {performanceMetrics?.map((entry, index) => {
            const fill = `var(--accent-${focusBar === index ? 10 : 6})`;
            return (
              <Cell
                radius={4}
                key={`cell-${index}`}
                mask="url(#mask-stripe)"
                fill={fill}
              />
            );
          })}
        </Bar>
      </BarChart>
    </ScrollAreaAutosize>
  );
}
